module.exports = __webpack_public_path__ + "img/risk_free.546d3cea.svg";